module.exports = __webpack_public_path__ + "img/BS11.13a39195.svg";